import { Stack } from "@altimateai/lego";
import { ClockRotate, DatastoreTestFail, DatastoreTestSuccess } from "@/assets/icons";

interface ConnectionStatusProps {
  status: "untested" | "success" | "failed";
  isLoading?: boolean;
}

export const ConnectionStatus = ({ status, isLoading }: ConnectionStatusProps) => {
  if (isLoading) {
    return (
      <Stack direction="row" align="center" className="al-gap-1 al-text-xs al-text-blue-600">
        <ClockRotate className="al-w-3 al-h-3 al-animate-spin" />
        <span>Running test... please wait</span>
      </Stack>
    );
  }

  if (status === "success") {
    return (
      <Stack direction="row" align="center" className="al-gap-1 al-text-xs al-text-green-600">
        <DatastoreTestSuccess className="al-w-3 al-h-3" />
        <span>Connection verified</span>
      </Stack>
    );
  }

  if (status === "failed") {
    return (
      <Stack direction="row" align="center" className="al-gap-1 al-text-xs al-text-red-600">
        <DatastoreTestFail className="al-w-3 al-h-3" />
        <span>Connection failed</span>
      </Stack>
    );
  }

  return null;
};
